export default __webpack_public_path__ + "static/media/at-outside.2ea18ae5.svg";